import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        data: []
    },
    reducers: {
        updateCartFromLocalStorage: (state, action) => {
            state.data = action.payload
        },
        addProductToCart: (state, action) => {
            const newProduct = action.payload;
            // Verifico se il prodotto (della stessa taglia) è presente nel carrello
            const existingProduct = state.data.find(element => element.productId === newProduct.productId && element.size === newProduct.size);
            if (existingProduct) { // Se lo è ne aggiorno la quantità
                const array = [...state.data];
                const newArray = array.map(element => {
                    if (element.productId === newProduct.productId && element.size === newProduct.size) {
                        let updatedProduct = { ...element };
                        updatedProduct.quantity = Number(element.quantity) + Number(newProduct.quantity);
                        return updatedProduct;
                    } else {
                        return element
                    }
                }).filter(element => element.quantity !== 0);
                state.data = newArray;
            } else { // Altrimenti lo aggiungo come nuovo prodotto
                newProduct.quantity = Number(newProduct.quantity)
                state.data.push(newProduct);
            }
            // Aggiorno il localStorage per la persistenza
            const serializedState = JSON.stringify(state.data);
            localStorage.setItem('ticino-wild-cart', serializedState);
        },
        removeProductFromCart: (state, action) => {
            const product = action.payload;
            state.data = state.data.filter(element => element.productId !== product.productId || (element.productId === product.productId && element.size !== product.size));
            // Aggiorno il localStorage per la persistenza
            const serializedState = JSON.stringify(state.data);
            localStorage.setItem('ticino-wild-cart', serializedState);
        },
        emptyCart: (state) => {
            state.data = [];
        }
    }
})

export const { addProductToCart, updateCartFromLocalStorage, removeProductFromCart, emptyCart } = cartSlice.actions;
export default cartSlice.reducer;